import gql from 'graphql-tag';

export default gql`
mutation ($id: String!, $name: String, $version: Int!, $startDate: String!, $endDate: String!, $brand: String, $layers: [CampaignLayerInput]) {
    updateCampaign (input: {
        id: $id
        name: $name
        version: $version
        startDate: $startDate
        endDate: $endDate
        brand: $brand
        layers: $layers
    }) {
        __typename
        id
        version
        name
        advertiserId
        advertiser {
            name
        }
        startDate
        endDate
        brand
        layers {
          id
          name
        }
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Campaigns/UpdateMutation.js